module.exports = __webpack_public_path__ + "static/img/tooltip-orbit-definition.8324b87.png";